<script lang="ts" setup>
import SectionIntro360 from '~/components/sections/SectionIntro360.vue'
import SectionOurProducts from '~/components/sections/SectionOurProducts.vue'
import SectionServices from '~/components/sections/SectionServices.vue'

import SectionContactWithRows from "@/components/sections/SectionContactWithRows.vue";

useSeoMeta({
  title: 'Hospitality Hygiene Solutions in Zanzibar | Altracare',
  description: 'Hospitality hygiene solutions in Zanzibar for hotels, resorts and clinics. Altracare delivers 360-degree support with ethanol blends and essential chemicals.',
  ogTitle: 'Hospitality Hygiene Solutions in Zanzibar | Altracare',
  ogDescription: 'Hospitality hygiene solutions in Zanzibar for hotels, resorts and clinics. Altracare delivers 360-degree support with ethanol blends and essential chemicals.',
  ogType: 'website',
  twitterCard: 'summary_large_image'
})

const router = useRouter()
const { $api } = useNuxtApp()
const { $io } = useNuxtApp()


const { hero } = useHero()

onMounted(() => {
  hero({
    base: {
      class: 'min-h-500px! t:max-h-80vh!'
    },
    media: {
      type: 'image',
      media: {
        src: '',
        alt: '',
      }
    },
    content: {
      component: 'HomeHero',
      content: {
        title: 'Home',
        description: 'Home',
      }
    },
    
  })

})

</script>
<template>
  <div class="page-home">


    <Frame class="sec-intro">
      <SectionIntro360 />
    </Frame>

    
    <SectionOurProducts />

    <SectionServices />
  
    <SectionContactWithRows id="contactus" />

    <!-- Introduction Section -->
    <!-- <SectionIntroduction /> -->
    
    <!-- 360 Service Section -->
    <!-- <Section360Service /> -->

    <!-- Solutions & Products Section -->
    <!-- <client-only>
            <Frame class="framer-solutions relative">
              <SectionTitle id="offerings" class="sec-offerings-title lt-ds:bg-white gpb-1 ds:gpb-2"
                :class="{ 'ds:sticky! ds:top--200px ds:z-10': stickyMode }" small="Contact us for custom solutions"
                primary="Solutions & Products"
                description="Discover our extensive solutions and explore the industries where we have a proven track record."
                w="relative">
                <template #top>
                  <LineCheckpoint class="relative! translate-x-0% -translate-y-25% t:absolute! t:-translate-y-75% t:-translate-x-130%" id="solution" />
                </template>
                <template #bottom>
                  <Section class="sec-services-header gpt-2 t:gpt-3 ds:gpt-4.5 ds:gpl-2.5" :class="{ 'sticky-mode': stickyMode }"
                    w="flex max-w-85% mx-auto">
                    <Section class="sec-offerings-select mr-auto "
                      w="flex g-1 t:g-3 items-center lt-t:flex lt-t:flex-col lt-t:g-1">
                      <div class="sec-offer-option sec-select">
                        <SelectButton :allowEmpty="false" class="services-select-button mpd-selectbutton" v-model="offering"
                          :options="offerings" aria-labelledby="basic" />
                      </div>
                      <transition name="fade" mode="out-in">
                        <div key="arrow" class="sec-option-label flex items-center g-1 lt-ds:hidden">
                          <div class="sec-arrow-left">
                            <i class="flex items-center justify-center i i-mdi:arrow-left" />
                          </div>
                          Select an option to discover more solutions
                        </div>
                      </transition>
                    </Section>

                    <Section class="sec-solutions-meta ml-auto flex items-end lt-t:hidden" w="flex g-0.5">


                      <div v-if="offering === 'Solutions'" class="mpd" key="solutions">
                        <Button @click="router.push('/solutions')" class="mpd">
                          All Solutions
                        </Button>
                      </div>
                      <div v-if="offering === 'Products'" class="mpd" key="products">
                        <Button btn="blue" class="gpy-0.75 gpx-1.25 fs--1 fw-600" @click="router.push('/products')">
                          All Products
                        </Button>
                      </div>


                    </Section>
                  </Section>

                </template>
              </SectionTitle>

              <Section class="sec-select-button-carousels gpb-0">
                <SectionSolutionsCarousel ref="solutionsCarousel" key="solutions" v-if="offering === 'Solutions'" />
                <SectionSolutionsProducts v-else-if="offering === 'Products'" key="products" />
              </Section>
            </Frame>
    </client-only> -->
    
    <!-- Why Altracare Section -->
    <!-- <SectionWhyAltracare /> -->
    
    <!-- Testimonials Section -->
    <!-- <SectionTestimonials /> -->
    
    <!-- Contact Section -->
    <!-- <SectionContact /> -->

  </div>
</template>

<style scoped lang="scss">

</style>
